import { Box, Group } from '@optiaxiom/react';

import { typingDot, typingDots } from './TypingDots.css';

/** Three bouncing dots, e.g. for a chat bubble waiting on a reply. */
export const TypingDots = () => (
  <Group className={typingDots} flexDirection="row">
    <Box className={typingDot} />
    <Box className={typingDot} />
    <Box className={typingDot} />
  </Group>
);
